export default __webpack_public_path__ + "static/media/bg.050fdf09.png";